export default __webpack_public_path__ + "static/media/04.0cd9cb7a.jpg";